export default "__VITE_ASSET__BdxQFG_9__"